import React from "react";
import { node } from "prop-types";
import { classes } from "@insightfulscience/atomic-react/utils/classes";
import Inline from "@insightfulscience/atomic-react/Inline";
import { Col, Row } from "../Grid";
import Link from "../Link";

const TopBarNav = ({ children }) => (
	<Col auto>
		<Row px utility={{ align: { items: "center" } }}>
			{children}
		</Row>
	</Col>
);

TopBarNav.propTypes = {
	children: node.isRequired,
};

export const TopBarNavItem = ({ forwardRef, children, className = "", ...props }) => (
	<Col forwardRef={forwardRef} className={classes("topbar__nav-item", className)} shrink {...props}>
		{children}
	</Col>
);

TopBarNavItem.propTypes = {
	...Col.propTypes,
};

export const TopBarNavItemLink = ({ className = "", ...props }) => {
	return (
		<Link
			isBaseClassName={false}
			className={classes("topbar__nav-item-link", className)}
			{...props}
		/>
	);
};

TopBarNavItemLink.propTypes = {
	...Link.propTypes,
};

export const TopBarNavItemInline = ({ className = "", isOpen, ...props }) => {
	return <Inline className={classes("topbar__nav-item-inline", className)} {...props} />;
};

TopBarNavItemInline.propTypes = {
	...Inline.propTypes,
};

export default TopBarNav;
